import React, { useEffect } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './carousel.styles.scss'
import { Content as EntryContent } from './Entry'

/**
 * カルーセルの矢印のスタイル
 */
const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
}

const settings3 = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
}

/**
 *
 */
const Entry = ({ data }) => {
  const isBrowser = typeof window !== 'undefined'
  const BlakePoint1 = 1130
  const BlakePoint2 = 767
  const getWidth = () => {
    if (isBrowser) {
      return window.innerWidth
    }
    return 0
  }
  const [width, setWidth] = React.useState(getWidth())
  const updateWidth = () => {
    if (isBrowser) {
      setWidth(window.innerWidth)
    }
  }

  useEffect(() => {
    if (isBrowser) {
      window.addEventListener(`resize`, updateWidth, {
        capture: false,
        passive: true,
      })
      return () => window.removeEventListener(`resize`, updateWidth)
    }
  }, [width])

  if (width > BlakePoint2) {
    return (
      <Slider {...settings}>
        {data.map((entry, index) => {
          return <EntryContent entry={entry} key={index} />
        })}
      </Slider>
    )
  }
  return (
    <Slider {...settings3}>
      {data.map((entry, index) => {
        return <EntryContent entry={entry} key={index} />
      })}
    </Slider>
  )
}

/**
 *
 */
export const Content = ({ data }) => {
  return <Entry data={data} />
}
